import React, { useState } from "react";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import { getStorageData } from "utils/helper";
import { Modal } from "react-bootstrap";
import { DOMAIN_CLINKS } from "constants/app";
import { claimOrg } from "apiServices/app";
import TextBoxComponent from "components/FormsComponents/TextBoxComponent";
import { FaPaperPlane } from "react-icons/fa";
import { OrgclaiMSvgIcn } from "svgIcon";

const ClaimOrgModalComponent = ({
  showModal,
  setShowModal,
  setShowSuccess,
  agencyId,
  setMsgType,
}) => {
  const domain = getStorageData("domain");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState();

  const handleClose = () => {
    setShowModal(false);
  };
  const [formData, setFormData] = useState({
    domain_status: domain === DOMAIN_CLINKS ? true : false,
    email: "",
  });

  const handleInput = ({ target: { name, value } }) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" });
  };
  const handleStore = () => {
    if (formData.email != "") {
      claimOrganisation();
    } else {
      setErrors({ email: "This field is required" });
    }
  };

  const claimOrganisation = () => {
    setLoader(true);
    claimOrg({ ...formData, agency_id: agencyId })
      .then(({ data, success, msg }) => {
        if (success === "true") {
          setShowModal(false);
          setMsgType(data?.popup_status);
          setShowSuccess(true); // Show success modal
          setLoader(false);
        }
      })
      .catch((err) => {
        const {
          error: { error = {} },
        } = err;
        if (Object.entries(error).length !== 0) {
          setErrors({ ...errors, email: error.email[0] });
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };
  return (
    <>
      <Modal
        backdrop="static"
        className="claim__modal"
        show={showModal}
        onHide={handleClose}
        keyboard={false}
      >
        <Modal.Body>
          <Modal.Header closeButton className="p-0 border-0"></Modal.Header>
          <div className="py-3 px-2">
            <div className="d-flex flex-column align-items-center mb-4">
              <div className="mmail__icn claimmm__icn rounded-pill d-flex align-items-center justify-content-center mb-4">
                <OrgclaiMSvgIcn />
              </div>
              <h5 className="mb-2 fw-bold text-dark text-center">
                Claim This Organisation
              </h5>
              <p className="mb-0 fw-normal text-center">
                Enter your email address to start the claim process.
              </p>
            </div>
            <div className="d-flex flex-column align-items-center justify-content-center gap-3">
              <TextBoxComponent
                name="email"
                label="Email"
                type="email"
                value={formData && formData.email}
                title="Enter email address"
                handleInput={handleInput}
                placeholder="Enter email address"
                errors={errors && errors.email}
                className="form-control-lg"
              />
              <ButtonComponent
                variant="dark w-100"
                disabled={formData && formData.email ? loader : true}
                onClick={handleStore}
                title="Claim Now"
              >
                Claim Now
              </ButtonComponent>
              <ButtonComponent
                variant="link"
                className="w-100 p-0 mt-2"
                onClick={handleClose}
                title="No Thanks, Close"
              >
                No Thanks, Close
              </ButtonComponent>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ClaimOrgModalComponent;
